<template lang="pug">
  <div>
    nav.navbar-fixed.mp0.light-blue.darken-4
      .nav-wrapper
        a(href="#!" class="brand-logo left") 
          .logo 
        ul.right.hide-on-sm-and-down
          li: router-link( to="/back-office") Solicitudes
          li: router-link( to="/back-office/usuarios") Usuarios
          li: router-link( to="/back-office/unidad_operadores") Operadores & Unidades
  </div>
</template>
<script>
export default {
  name: "NavBarBackOffice",
}
</script>